import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Subscriptions module configurations
export const LISTING_COLUMNS = [
  {
    id: 'subscriberName',
    label: 'Subscriber',
    width: '10%',
    align: 'left',
    dataKey: 'subscriberName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'username',
        type: CELL_DATA_TYPES.TEXT,
      },
      {
        dataKey: 'email',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'channel',
    label: 'Channel',
    width: '10%',
    align: 'left',
    dataKey: 'channel',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'type',
        type: CELL_DATA_TYPES.TEXT,
      },
      {
        dataKey: 'platform',
        type: CELL_DATA_TYPES.PLATFORM,
      },
    ],
  },
  {
    id: 'sku',
    label: 'Product',
    width: '5%',
    align: 'left',
    dataKey: 'sku',
    sortable: true,
    type: CELL_DATA_TYPES.SUBSCRIPTION_SKU,
  },
  {
    id: 'reason',
    label: 'Reason',
    width: '15%',
    align: 'left',
    dataKey: 'reason',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'requestedAt',
    label: 'Requested At',
    width: '5%',
    align: 'left',
    dataKey: 'requestedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'subscriptionCancelAt',
    label: 'Cancel At',
    width: '5%',
    align: 'left',
    dataKey: 'subscriptionCancelAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'subscriberName',
    label: 'Subscriber',
    dataKey: 'subscriberName',
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'username',
        type: CELL_DATA_TYPES.TEXT,
      },
      {
        dataKey: 'email',
        type: CELL_DATA_TYPES.EMAIL,
      },
    ],
  },
  {
    id: 'channel',
    label: 'Channel',
    dataKey: 'channel',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'type',
    label: 'Type',
    dataKey: 'type',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sku',
    label: 'Product',
    dataKey: 'sku',
    type: CELL_DATA_TYPES.SUBSCRIPTION_SKU,
  },
  {
    id: 'videoTitle',
    label: 'Video',
    dataKey: 'videoTitle',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'platform',
    label: 'Platform',
    dataKey: 'platform',
    type: CELL_DATA_TYPES.PLATFORM,
  },
  {
    id: 'ip',
    label: 'IP Adderess',
    dataKey: 'ip',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'reason',
    label: 'Reason',
    dataKey: 'reason',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'requestedAt',
    label: 'Requested At',
    dataKey: 'requestedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'subscriptionCancelAt',
    label: 'Cancel At',
    dataKey: 'subscriptionCancelAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
